import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import SelectLocationsProducts from './select-locations-products';
import ContractingYear from './contracting-year';
import R from 'ramda';
import { TextField, FontIcon } from 'material-ui';
import RateTypeForm from '../../../generic-components/rate-forms/RateType';
import moment from 'moment';
const currentYear = new Date().getFullYear();
const getDatesByCountry = (country) => {
  if (country === 'United States' || country === 'United Kingdom') {
    return {
      dateLabel: country === 'United States' ?
        `Jan 01 ${currentYear + 1} - Dec 31 ${currentYear + 1}`
        : `01 Jan ${currentYear + 1} - 31 Dec ${currentYear + 1}`,
      startDate: `${currentYear + 1}-01-01 00:00:00.000Z`,
      endDate: `${currentYear + 1}-12-31 00:00:00.000Z`,
    };
  }
  return {
    dateLabel: `01 Apr ${currentYear + 1} - 31 Mar ${currentYear + 2}`,
    startDate: `${currentYear + 1}-04-01 00:00:00.000Z`,
    endDate: `${currentYear + 2}-03-31 00:00:00.000Z`,
  };
};
class CreateTemplateDraft extends Component {
  constructor() {
    super();
  }
  // handleQuickStartClick = obj => () => {
  //   this.props.updateProps({
  //     quickStartSelected: obj,
  //     newDraftName: `${obj.dateLabel} ${obj.rateType === 'nett' ? 'Nett' : `${obj.commissionPercentage}%`} Rate Template`,
  //     draftRateType: obj.rateType,
  //     draftCommissionPercentage: obj.commissionPercentage,
  //     draftNettCommission: obj.nettCommission,
  //     newDraftStartDate: obj.startDate,
  //     newDraftEndDate: obj.endDate,
  //   });
  // };
  // handleCustomClick = () => {
  //   this.props.updateProps(this.props.hideDates ? {
  //     quickStartSelected: { type: 'custom' },
  //     newDraftName: `Rate Template`,
  //     draftRateType: '',
  //     draftCommissionPercentage: '',
  //   } : {
  //     quickStartSelected: { type: 'custom' },
  //     newDraftName: `Rate Template`,
  //     draftRateType: '',
  //     draftCommissionPercentage: '',
  //     newDraftStartDate: '',
  //     newDraftEndDate: '',
  //   });
  // };
  render() {
    const {
      updateProps,
      newDraftStartDate,
      newDraftEndDate,
      newDraftName,
      locations,
      hideDates,
      hasAccessToCreateLoc,
      isSingleLoc,
      country,
      draftRateType,
      draftCommissionPercentage,
      draftNettCommission,
      quickStartSelected,
    } = this.props;
    const nextStep = Boolean(quickStartSelected.type);
    // const format = country === 'United States' ? 'MMM DD YYYY' : 'DD MMM YYYY';
    // const quickStartPeriod = hideDates ? {
    //   dateLabel: `${moment.utc(newDraftStartDate).format(format)} - ${moment.utc(newDraftEndDate).format(format)}`,
    //   startDate: newDraftStartDate,
    //   endDate: newDraftEndDate,
    // } : getDatesByCountry(country);
    // const quickStarts = [{
    //   type: 25,
    //   rateType: 'includeCommission',
    //   commissionPercentage: 25,
    //   ...quickStartPeriod,
    // },{
    //   type: 20,
    //   rateType: 'includeCommission',
    //   commissionPercentage: 20,
    //   ...quickStartPeriod,
    // }, {
    //   type: '0',
    //   rateType: 'nett',
    //   nettCommission: 0,
    //   ...quickStartPeriod,
    // }];
    return (
      <div style={{ maxWidth: '800px', margin: 'auto', paddingTop: '12px' }}>
        {/*<div className="flex-tc-sb">*/}
        {/*  {*/}
        {/*    quickStarts.map((obj, i) => {*/}
        {/*      const { rateType, commissionPercentage, dateLabel, type } = obj;*/}
        {/*      return (*/}
        {/*        <div*/}
        {/*          key={i}*/}
        {/*          style={{*/}
        {/*            width: '20%',*/}
        {/*            textAlign: 'center',*/}
        {/*            height: '130px',*/}
        {/*            border: '3px solid #e0e0e0',*/}
        {/*            marginTop: '16px',*/}
        {/*            cursor: 'pointer',*/}
        {/*            backgroundColor: quickStartSelected.type === type ? '#efefef' : 'white',*/}
        {/*          }}*/}
        {/*          onClick={this.handleQuickStartClick(obj)}*/}
        {/*        >*/}
        {/*          <div style={{ fontSize: '16px', margin: '24px auto' }}>*/}
        {/*            {rateType === 'nett' ? 'Nett Rate' : `${commissionPercentage}% Commission`}*/}
        {/*          </div>*/}
        {/*          <span style={{ fontSize: '9px' }}>*/}
        {/*          {dateLabel}*/}
        {/*        </span>*/}
        {/*        </div>*/}
        {/*      );*/}
        {/*    })*/}
        {/*  }*/}
        {/*  <div*/}
        {/*    style={{*/}
        {/*      width: '20%',*/}
        {/*      textAlign: 'center',*/}
        {/*      height: '120px',*/}
        {/*      border: '3px dashed #e0e0e0',*/}
        {/*      marginTop: '16px',*/}
        {/*      paddingTop: '12px',*/}
        {/*      cursor: 'pointer',*/}
        {/*      backgroundColor: quickStartSelected.type === 'custom' ? '#efefef' : 'white',*/}
        {/*    }}*/}
        {/*    data-cy="custom"*/}
        {/*    onClick={this.handleCustomClick}*/}
        {/*  >*/}
        {/*    <FontIcon className="tc-icon-add" style={{ fontSize: '50px', color: 'rgba(0, 0, 0, 0.54)' }} />*/}
        {/*    <br/>*/}
        {/*    Create Custom*/}
        {/*  </div>*/}
        {/*</div>*/}
        {
          nextStep && (
            <div style={{ marginTop: '16px' }}>
              {
                quickStartSelected.type && (
                  <div>
                    <label><b>Please enter a name for the template:</b></label> <span style={{ color: 'red' }}>* Required</span>
                    <TextField
                      data-cy="templateNameField"
                      style={{ display: 'block', width: '400px' }}
                      inputStyle={{ fontSize: '13px' }}
                      hintText="Name the new template"
                      value={newDraftName}
                      onChange={(_, value) => updateProps({ newDraftName: value, createDraftError: '' })}
                    />
                    {
                      !hideDates && (
                        <ContractingYear
                          required
                          startDate={newDraftStartDate}
                          endDate={newDraftEndDate}
                          onChange={(key, val) => updateProps({ [`newDraft${key === 'startDate' ? 'StartDate' : 'EndDate'}`]: val, createDraftError: '' })}
                        />
                      )
                    }
                    <label><b>Please select a rate type:</b></label>
                    <RateTypeForm
                      rateType={draftRateType}
                      commissionPercentage={draftCommissionPercentage}
                      nettCommission={draftNettCommission}
                      updateRateType={(value) => updateProps({ draftRateType: value })}
                      updateCommission={(value) => updateProps({ draftCommissionPercentage: value })}
                      updateNettCommission={(value) => updateProps({ draftNettCommission: value })}
                    />
                  </div>
                )
              }
              <div style={{ marginTop: '16px', display: nextStep ? 'block' : 'none' }}>
                <SelectLocationsProducts
                  style={{ width: '80%' }}
                  isSingleLoc={isSingleLoc}
                  hasAccessToCreateLoc={hasAccessToCreateLoc}
                  locations={locations}
                  updateProps={updateProps}
                  checkAllLocations={checked => {
                    const updatedLocations = locations.map(loc => {
                      return R.merge(loc, {
                        checked,
                        products: loc.products.map(R.merge(R.__, { checked })),
                      });
                    });
                    updateProps({ locations: updatedLocations, createDraftError: '' });
                  }}
                  checkLocation={(locationIndex, checked) => {
                    const updatedLocations = fromJS(locations).setIn([locationIndex, 'checked'], checked)
                    .updateIn([locationIndex, 'products'], products => products.map(product => product.set('checked', checked)));
                    updateProps({ locations: updatedLocations, createDraftError: '' });
                  }}
                  checkProduct={(locationIndex, productIndex, checked) => {
                    const updatedLocations = fromJS(locations).setIn([locationIndex, 'products', productIndex, 'checked'], checked);
                    updateProps({ locations: updatedLocations, createDraftError: '' });
                  }}
                />
              </div>
            </div>
          )
        }
      </div>
    );
  }
}

CreateTemplateDraft.propTypes = {
  updateProps: PropTypes.func,
  newDraftStartDate: PropTypes.string,
  newDraftEndDate: PropTypes.string,
  newDraftName: PropTypes.string,
  locations: PropTypes.array,
  hideDates: PropTypes.bool,
  hasAccessToCreateLoc: PropTypes.bool,
  isSingleLoc: PropTypes.bool,
  country: PropTypes.string,
  draftRateType: PropTypes.string,
  draftCommissionPercentage: PropTypes.number,
  draftNettCommission: PropTypes.number,
  quickStartSelected: PropTypes.object,
};

const mapStateToProps = ({ contracting, user }) => {
  return ({
    quickStartSelected: contracting.templateList.get('quickStartSelected')
      ? contracting.templateList.get('quickStartSelected').toJS()
      : {},
    newDraftStartDate: contracting.templateList.get('newDraftStartDate'),
    newDraftEndDate: contracting.templateList.get('newDraftEndDate'),
    newDraftName: contracting.templateList.get('newDraftName'),
    draftRateType: contracting.templateList.get('draftRateType'),
    draftCommissionPercentage: contracting.templateList.get('draftCommissionPercentage'),
    draftNettCommission: contracting.templateList.get('draftNettCommission'),
    locations: contracting.templateList.get('locations').toJS(),
    hasAccessToCreateLoc: R.contains('createLocation', user.get('corporateAccess') || []),
    isSingleLoc: user.getIn(['company', 'oneOrMultiProperties']) === 'one-prop',
    country: user.getIn(['company', 'address']).country,
  });
};

export default connect(mapStateToProps)(CreateTemplateDraft);



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/create-template-draft/components/create-draft-form.jsx